export default "/images/e897c53e3962fcddab5855b8e8df4f95.avif";